import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=c8293cf0&"
import script from "./AppTab.vue?vue&type=script&lang=js&"
export * from "./AppTab.vue?vue&type=script&lang=js&"
import style0 from "./AppTab.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports